import React from 'react';
import {
  PinIcon,
  BedIcon,
  BathIcon,
  ParkingIcon,
} from '@domain-group/fe-co-icon';
import { Stack, StackItem } from '@domain-group/fe-blueprint-ui/layout';
import * as styles from './styles';

const mapStates = (stateCode: string) => {
  const states: Record<string, string> = {
    ACT: 'ACT',
    NSW: 'NSW',
    QLD: 'QLD',
    SA: 'SA',
    TAS: 'TAS',
    VIC: 'VIC',
    WA: 'WA',
    'New South Wales': 'NSW',
    Queensland: 'QLD',
    'South Australia': 'SA',
    Tasmania: 'TAS',
    Victoria: 'VIC',
    'Western Australia': 'WA',
  };
  return states[stateCode] ?? '';
};

export type AddressProps = {
  streetAddress: string;
  suburb: string;
  state: string;
  postcode: string;
  bedrooms?: number;
  bathrooms?: number;
  carparks?: number;
};

const Address: React.FC<AddressProps> = ({
  streetAddress,
  suburb,
  state,
  postcode,
  bedrooms,
  bathrooms,
  carparks,
}) => (
  <Stack verticalAlign="center" gap="xs" wrap css={styles.addressContainer}>
    <StackItem>
      <Stack gap="xxs" verticalAlign="center">
        <StackItem align="center">
          <PinIcon />
        </StackItem>
        <StackItem css={styles.address}>
          {streetAddress}, {suburb} {mapStates(state)} {postcode}
        </StackItem>
      </Stack>
    </StackItem>
    <StackItem>·</StackItem>
    <StackItem>
      <Stack gap="xs" verticalAlign="center">
        <StackItem>
          <BedIcon width="20px" height="20px" /> {bedrooms ?? '-'}
        </StackItem>
        <StackItem>
          <BathIcon width="20px" height="20px" /> {bathrooms ?? '-'}
        </StackItem>
        <StackItem>
          <ParkingIcon width="20px" height="20px" /> {carparks ?? '-'}
        </StackItem>
      </Stack>
    </StackItem>
  </Stack>
);

export default Address;
